import type { JSX } from 'react';
import { cn } from '@/lib/utils';
import type { VerificationStatus } from '../types/verification.types';

interface ReturnedCommentProps {
  status: VerificationStatus;
  comment?: string | null;
  className?: string | undefined;
}

/**
 * The mandatory comment a super admin leaves when returning a verification.
 * Without it the agent has no way to know what to fix.
 */
export function ReturnedComment({
  status,
  comment,
  className,
}: ReturnedCommentProps): JSX.Element | null {
  if (status !== 'RETURNED' || !comment) {
    return null;
  }

  return (
    <p className={cn('text-xs text-purple-800', className)} title={comment}>
      Returned: {comment}
    </p>
  );
}
